import React from 'react';

import { ResellerTrendsImage } from './ResellerTrendsImage';
import './ResellerTrendsSlide.css';

export const ResellerTrendsSlide = (): React.ReactElement => {
  return (
    <div className="reseller-trends-slide py-0 px-6 flex justify-between" data-test-id="reseller-trends-slide">
      <div className="reseller-trends-slide-description pr-0 pb-4 pl-4 flex flex-column">
        <p className="reseller-trends-slide-header text-sm">In times of economic uncertainty:</p>
        <p className="reseller-trends-slide-item text-sm bg-brand-lightest mb-2 px-4">
          Does my portfolio mix capitalise on the{' '}
          <span className="font-bold">growth potential offered by emerging products?</span>
        </p>
        <p className="reseller-trends-slide-item reseller-trends-slide-item--highlighted text-sm bg-brand-light mb-2 px-4 border-brand-dark">
          How do I manage channel strategies to{' '}
          <span className="font-bold">react to varying enterprise growth across countries?</span>
        </p>
        <p className="reseller-trends-slide-item text-sm bg-brand-lightest mb-2 px-4">
          How can I track sales performance for our{' '}
          <span className="font-bold">top selling items to gain a competitive edge across channels?</span>
        </p>
      </div>
      <ResellerTrendsImage />
    </div>
  );
};
